import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {
  submitSelectedEMEIConfirmation,
  getGeneralData,
  saveCauseSelectionStepData,
  addCauseSelection,
  setCurrentStep,
  disableGoToNextStep,
  stepEnum,
  createNotification,
  changeHandler,
  setLockCodeExists,
  formName,
  notificationType,
  saveToHistory,
  changeCauseHandler,
  removeCauseSelection,
  setCauseList
} from '../IMEIDeviceRepairSlice';
import Title from '../Shared/Title';
import SelectCauseItem from '../Shared/SelectCauseItem';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import TextInput from '../../../Shared/TextInput/TextInput';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import lodash from 'lodash';
import {
  dwhCauseSelectionPageDisplay,
  dwhCauseSelectionButtonClick,
  dwhIDFCauseSelectionPageDisplay,
  dwhIDFCauseSelectionButtonClick,
  dwhPrivateTechnicalMalfunctionPageDisplayed,
  dwhPrivateTechnicalMalfunctionPageButtonClick
} from '../reports/dwhReports';
import {gtag4} from 'app/utilities/analytics/tracking';
import SelectList from 'app/Components/Shared/SelectList/SelectList';
import {isMobile} from 'react-device-detect';

const CauseSelection = ({deviceRepairData, portalState, ...props}) => {
  const [paymentAgreement, setPaymentAgreement] = useState(false);
  const [errorAgreement, setErrorAgreement] = useState(false);
  const [resetErrorAgreement, setErrorResetAgreement] = useState(false);
  const [error, setError] = useState('');
  const [securityCodeExistsChanged, setSecurityCodeExistsChanged] = useState(false);
  const [causeOptions, setCauseOptions] = useState([]);
  const [alternatePhoneChanged, setAlternatePhoneChanged] = useState(false);
  const {
    dwhData,
    selectCauseForm,
    createNotificationTicketNumber,
    isPrivate,
    selectedPhoneNumber,
    selectedIMEI,
    selectedAccountOrgName,
      securityCode,
      alternatePhone
  } = deviceRepairData;
  const {selectedHetPay, customerName, subscriber} = dwhData;


  // Constants
  const agreementErrorText = 'נא לאשר';
  const generalSelectBoxOptions = [
    {value: false, key: 'לא'},
    {value: true, key: 'כן'}
  ];

  useEffect(() => {
    if (!deviceRepairData.causeSelectionList) {
      props.getGeneralData();
    }
    setTimeout(() => {
      props.saveToHistory('cause');
    }, 2000);
    const param2 = selectCauseForm.causeList[0].selectedCauseType;
    const param3 = selectCauseForm.causeList[0].selectedCauseSubType;
    if (isPrivate) {
      dwhIDFCauseSelectionPageDisplay({customerName, subscriber, param2, param3})
      return;
    }
    if (props.contentData.isFromPrivateSelfcare.value) {
      dwhPrivateTechnicalMalfunctionPageDisplayed({selectedHetPay, subscriber, selectedIMEI, customerName, selectedAccountOrgName})
    }
    else{
      dwhCauseSelectionPageDisplay({selectedHetPay, customerName, subscriber, selectedPhoneNumber});
    }
  }, []);

  useEffect(() => {
    if (deviceRepairData.createNotificationTicketNumber && deviceRepairData.goToNextStep) {
      saveToHistoryAndContinue();
    }
  }, [deviceRepairData.createNotificationTicketNumber]);

  useEffect(() => {
    deviceRepairData.causeSelectionList?.map((item) => {
      let subOptions = [];
      item.causeSubType.map((sub) => {
        const subOption = {key: sub.causeSubTypeId, value: sub.causeSubTypeValue};
        subOptions.push(subOption);
      });
      let option = {key: item.causeTypeId, value: item.causeTypeValue, subOptions: subOptions};
      setCauseOptions((oldArray) => [...oldArray, option]);
    });
  }, [deviceRepairData.causeSelectionList]);


  async function saveToHistoryAndContinue() {
    await props.disableGoToNextStep(); //browser back button
    await props.saveToHistory();
    props.setCurrentStep(stepEnum.PICK_UP_ADDRESS);
  }

  const clearContentRequired = (flag) => {
    props.changeHandler({
      name: 'clearContent',
      value: flag,
      rule: '',
      form: formName.selectCauseForm,
    });
  };

  const alternatePhoneRequired = (e) => {
    props.changeHandler({
      name: 'alternatePhone',
      value: e,
      rule: '',
      form: formName.selectCauseForm,
    });
    if (!alternatePhoneChanged) {
      setAlternatePhoneChanged(true);
      setError('');
    }
  };

  function handleInputChange(e) {
    const name = e.target.getAttribute('name');
    props.changeHandler({
      name: e.target.getAttribute('name'),
      value: e.target.value,
      rule: selectCauseForm?.rules[name],
      form: formName.selectCauseForm,
    });
  }

  function getCauseListString(selectCauseForm) {
    let causeList = selectCauseForm.map((cause) => {
      return `CAUSE_GROUP: ${cause.selectedCauseType}, CAUSE_CODE: ${cause.selectedCauseSubType}`;
    });
    return causeList.join(', ');
  }
  const validateRequest = () => {
    setError('');
    let validForm = true;
    selectCauseForm.causeList.map((item, index) => {
      if (!item.selectedCauseType?.trim() || !item.selectedCauseSubType?.trim()) {
        validForm = false;
      }
      props.changeCauseHandler({
        name: 'selectedCauseType',
        value: item.selectedCauseType,
        rule: selectCauseForm.rules['selectedCauseType'],
        index: index,
      });

      props.changeCauseHandler({
        name: 'selectedCauseSubType',
        value: item.selectedCauseSubType,
        rule: selectCauseForm.rules['selectedCauseSubType'],
        index: index,
      });
    });

    if (selectCauseForm.lockCodeExists && selectCauseForm.securityCode === '') {
      props.changeHandler({
        name: 'securityCode',
        value: '',
        rule: selectCauseForm.rules['securityCode'],
        form: formName.selectCauseForm,
      });
      validForm = false;
    }
    if (!paymentAgreement && props.contentData.isFromPrivateSelfcare.value) {
      setErrorAgreement(true);
      validForm = false;
    }
    if (!selectCauseForm.clearContent) {
      setErrorResetAgreement(true);
      validForm = false;
    }
    if (!alternatePhoneChanged) {
      setError('כדי להמשיך עליך לבחור האם לספק מכשיר חלופי');
      validForm = false;
      return validForm;

    }
    if (!securityCodeExistsChanged) {
      setError('כדי להמשיך עליך לבחור האם קיים קוד נעילה');
      validForm = false;
    }
    return validForm;
  };

  const submitCauseSelection = async () => {
    if (validateRequest()) {
      if (
        !deviceRepairData.createNotificationTicketNumber ||
        !lodash.isEqual(selectCauseForm, deviceRepairData.createNotificationUsedData)
      ) {
        let causeList = [];
        selectCauseForm.causeList.map((cause) => {
          let item = {CAUSE_GROUP: cause.selectedCauseType, CAUSE_CODE: cause.selectedCauseSubType};

          causeList.push(item);
        });

        const param2 = selectCauseForm.causeList[0].selectedCauseType;
        const param3 = selectCauseForm.causeList[0].selectedCauseSubType;
        const provideAlternatePhone = selectCauseForm.alternatePhone;
        const lockscreenCode = selectCauseForm.securityCode;
        props.setCauseList(getCauseListString(causeList));
        if (isPrivate) {
          dwhIDFCauseSelectionButtonClick({customerName,subscriber,param2,param3})
        } else if (props.contentData.isFromPrivateSelfcare.value) {
          dwhPrivateTechnicalMalfunctionPageButtonClick({
            selectedHetPay,
            subscriber,
            selectedIMEI,
            causeList,
            alternatePhone,
            securityCode,
            customerName,
            selectedAccountOrgName
          })
        } else {
          dwhCauseSelectionButtonClick({selectedHetPay, customerName, subscriber, selectedPhoneNumber, param2, param3});
        }
        const createNotificationReq = {
          selectedNumber: selectedPhoneNumber,
          selectedIMEI: deviceRepairData.selectedIMEI,
          causeList: causeList,
          lockCode: selectCauseForm.securityCode,
          alternatePhone: selectCauseForm.alternatePhone,
          clearContent: selectCauseForm.clearContent,
          notificationType: notificationType.CREATE_NOTIFICATION,
          isPrivate: deviceRepairData.isPrivate,
          isFromPrivateSelfCare: props.contentData.isFromPrivateSelfcare.value === true
        };
        await props.saveCauseSelectionStepData();

        gtag4({
          event: 'DeviceRepair_RepairInfoContinueButton',
          action: 'RepairInfoContinueButton',
          button: `המשך`,
        });
        props.createNotification(createNotificationReq);
      } else {
        props.setCurrentStep(stepEnum.PICK_UP_ADDRESS);
      }
    }
  };

  const handleLockCodeExists = (e) => {
    setSecurityCodeExistsChanged(true);
    props.setLockCodeExists(e);
    setError('');
  };

  return (
    <div className='cause-selection-wrapper'>
      <Title text={'תאום שליחות לתיקון מכשיר'} subtext={'מהו סוג התקלה?'} />

      <div className="cause-selection-form">
        {selectCauseForm.causeList.map((cause, index) => {
          return (
            <div className="cause-select-item" key={index}>
              {selectCauseForm.causeList?.length > 1 && (
                <div onClick={() => props.removeCauseSelection(index)} className="remove-cause-button">
                  <svg width="16" height="16" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M21.556 3.043a1.528 1.528 0 0 0-2.139 0L12 10.329 4.582 3.028a1.528 1.528 0 0 0-2.138 0 1.47 1.47 0 0 0 0 2.105l7.417 7.3-7.417 7.302a1.47 1.47 0 0 0 0 2.105 1.528 1.528 0 0 0 2.138 0L12 14.539l7.418 7.3a1.528 1.528 0 0 0 2.138 0 1.47 1.47 0 0 0 0-2.104l-7.417-7.301 7.417-7.301a1.48 1.48 0 0 0 0-2.09z"
                      fill="#000"
                    />
                  </svg>
                </div>
              )}
              <SelectCauseItem key={index} index={index} options={causeOptions} />
            </div>
          );
        })}
        <div onClick={() => props.addCauseSelection()} className="add-cause-button">
          <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="7.25" y="4" width="1.5" height="8" rx=".75" fill="#000" />
            <path fillRule="evenodd" clipRule="evenodd" d="M4.75 8.75a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5h-6.5z"
                  fill="#000" />
          </svg>
          סוג תקלה נוסף
        </div>

        <div className={'choice-container'}>
          <span className={'cause-selection-subtitle'}>האם לספק מכשיר חלופי?</span>
          <SelectList options={generalSelectBoxOptions}
                      onClick={(e) => alternatePhoneRequired(e)} />
        </div>

        <div className={'choice-container'}>
          <span className={'cause-selection-subtitle'}>האם קיים קוד נעילה?</span>
          <SelectList options={generalSelectBoxOptions}
                      onClick={(e) => handleLockCodeExists(e)} />
        </div>

        {selectCauseForm.lockCodeExists && (
          <div className="d-flex security-code">
              <span className={'cause-selection-subtitle'}>
                  מה קוד הנעילה שלך?<span className={'cellcom-color'}> * </span></span>
            <span className={'security-code-text'}>במידה והקוד הוא ציור יש להתייחס אליו{isMobile &&
              <br />} כספרות 1-9</span>
            <TextInput
              error={selectCauseForm.errors.securityCode}
              placeholder="נא להזין קוד "
              onChange={(e) => (handleInputChange(e))}
              value={selectCauseForm.securityCode}
              name={'securityCode'}
              type="text"
              required={selectCauseForm.lockCodeExists ?? 'required'}
              disabled={!selectCauseForm.lockCodeExists}
            />
          </div>
        )}

        <div className={'checkboxes'}>
          <CheckBox
            checked={selectCauseForm.clearContent}
            label={`אני מאשר לאפס תכנים במידת הצורך`}
            id="reset"
            onCheck={() => {
              clearContentRequired(true), setErrorResetAgreement(false);
            }}
            onUncheck={() => clearContentRequired(false)}
            error={resetErrorAgreement ? agreementErrorText : ''}
          />
          {props.contentData.isFromPrivateSelfcare.value &&
          <CheckBox
            checked={paymentAgreement}
            label={`אני מאשר/ת, כי ידוע לי שתיקון המכשיר כרוך בתוספת תשלום דמי השתתפות עצמית וכי בדקתי עם איש הקשר בארגון אליו אני שייך/ת את עלות דמי ההשתתפות העצמית.`}
            id="payment"
            onCheck={() => {
              setPaymentAgreement(true), setErrorAgreement(false);
            }}
            onUncheck={() => setPaymentAgreement(false)}
            error={errorAgreement ? agreementErrorText : ''}
          />}
        </div>
        <div className="submit-button-container">
          <span className="error-message cellcom-color">{error}</span>
          <BtnSubmit text={'המשך'} onclick={() => submitCauseSelection()} />
        </div>
      </div>

    </div>
  );
};

const mapStateToProps = (state) => {
  return {deviceRepairData: state.iMEIDeviceRepair, portalState: state.portalsBlock};
};

const mapDispatchToProps = {
  submitSelectedEMEIConfirmation,
  getGeneralData,
  saveCauseSelectionStepData,
  addCauseSelection,
  setCurrentStep,
  disableGoToNextStep,
  createNotification,
  changeHandler,
  setLockCodeExists,
  saveToHistory,
  changeCauseHandler,
  removeCauseSelection,
  setCauseList
};

export default connect(mapStateToProps, mapDispatchToProps)(CauseSelection);
